import i18n from 'i18next';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';
import langStore from 'store/language';

const resources = {
  en: {
    translation: require('./language/enCommon.json'),
  },
  id: {
    translation: require('./language/idCommon.json'),
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: langStore.getLan(),
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', function(lng) {
  moment.locale(lng);
});

export default i18n;
